import { useFormikContext } from 'formik';
import { usePrompt } from 'hooks';
import { useTranslation } from 'react-i18next';

const FormNavigationBlocker = ({ alsoDirty = false }) => {
  const { dirty, isSubmitting } = useFormikContext();
  const { t } = useTranslation();

  usePrompt(t('misc:exitWithoutSave'), (dirty || alsoDirty) && !isSubmitting);

  return null;
};

export default FormNavigationBlocker;
